import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export interface ConfirmDialogData {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  destructive?: boolean;
}

@Component({
  selector: 'app-confirm-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  template: `
    <header class="confirm-dialog__header">
      <div class="confirm-dialog__title">
        <span class="confirm-dialog__warning" aria-hidden="true">
          <mat-icon>warning</mat-icon>
        </span>
        <h2 mat-dialog-title>{{ data.title }}</h2>
      </div>
      <button
        mat-icon-button
        class="confirm-dialog__close"
        [mat-dialog-close]="false"
        aria-label="Close confirmation dialog"
        title="Close confirmation dialog"
      >
        <mat-icon aria-hidden="true">close</mat-icon>
      </button>
    </header>
    <mat-dialog-content class="confirm-dialog__content">
      <p>{{ data.message }}</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="confirm-dialog__actions">
      <button
        mat-button
        class="confirm-dialog__button confirm-dialog__button--secondary"
        [mat-dialog-close]="false"
        [attr.aria-label]="data.cancelLabel ?? 'Cancel'"
        [attr.title]="data.cancelLabel ?? 'Cancel'"
      >
        {{ data.cancelLabel ?? 'Cancel' }}
      </button>
      <button
        mat-flat-button
        class="confirm-dialog__button confirm-dialog__button--confirm"
        [class.confirm-dialog__button--destructive]="data.destructive"
        [color]="data.destructive ? 'warn' : 'primary'"
        [mat-dialog-close]="true"
        [attr.aria-label]="data.confirmLabel ?? 'Confirm'"
        [attr.title]="data.confirmLabel ?? 'Confirm'"
      >
        {{ data.confirmLabel ?? 'Confirm' }}
      </button>
    </mat-dialog-actions>
  `,
  styleUrl: './confirm-dialog.component.scss',
})
export class ConfirmDialogComponent {
  data = inject<ConfirmDialogData>(MAT_DIALOG_DATA);
}
